export default __webpack_public_path__ + "static/media/pic_orderstep_02.223f05e3.png";